import React from "react";
import {
  IconTitleDescriptionActionCard,
  SectionContainerBase,
} from "@reusejs/react";

let sectionDetails = {
  title: "Help centre",
  description:
    "Here are some of the most frequesntly asked questions for more information.",
};

export default function FaqHeading() {
  return (
    <SectionContainerBase
      sectionContainerBaseClasses={{
        outerContainerStyles: "bg-gray-50 overflow-hidden py-10 md:py-16",
        innerContainerStyles: "max-w-7xl mx-auto px-4 sm:px-6 xl:px-0",
      }}
    >
      <Heading
        title={sectionDetails.title}
        description={sectionDetails.description}
      />
    </SectionContainerBase>
  );
}

const Heading = (props: any) => {
  return (
    <IconTitleDescriptionActionCard
      title={props.title}
      description={props.description}
      itemTitleDescriptionCardBaseClasses={{
        titleWrapper: "text-left",
        titleStyles:
          "text-3xl font-extrabold text-gray-900 sm:text-3xl sm:leading-none sm:tracking-tight lg:text-4xl",
        descriptionWrapper: "text-left mt-4 ",
        descriptionStyles: "max-w-xl text-base text-gray-500",
      }}
    />
  );
};
